var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCovideoSmallLogoInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19971 1.61816L0 5.99926V11.9985L4.20105 16.4106L8.23003 12.7899V5.08375L4.19971 1.61816Z",
    fill: "#9297A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9998 8.67572V5.99921L13.2823 0H5.75136L4.44287 1.36433L12.9225 8.67572H18.9998Z",
    fill: "#9297A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9212 9.0343L4.44287 16.6648L5.71506 18H13.2823L18.9998 11.9984V9.0343H12.9212Z",
    fill: "#9297A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCovideoSmallLogoInactive);
export default __webpack_public_path__ + "static/media/covideoSmallLogoInactive.f791c7569488ddff308d8e53fe0ef749.svg";
export { ForwardRef as ReactComponent };